import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useModal } from "../../ModalProvider/ModalProvider";
import AssignTo from "./AssignTo/AssignTo";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

import { createOrderAssignment } from "../../../utilities/api";

export default function SelfManageModalContent({ ticketType, eventId }) {
  const [isSaving, setIsSaving] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const isComplimentary = ticketType === "comp";
  const [step, setStep] = useState(2);
  const [assignTo, setAssignTo] = useState({
    organizationName: "",
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: null,
    deposit: 0,
    maxSeatsAllowed: 0,
    selfManage: true,
  });
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [isValidNumber, setIsValidNumber] = useState(true);

  const { closeModal } = useModal();

  const handleSave = () => {
    const data = {};
    data["invoice"] = assignTo;
    data["eventUUID"] = eventId;

    createOrderAssignment(data)
      .then((res) => {
        console.log(res);
        closeModal();
      })
      .catch((err) => console.error(err));
  };

  const handleAssignToChange = (field, value) => {
    setAssignTo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (
      assignTo.firstName &&
      assignTo.lastName &&
      assignTo.email &&
      assignTo.deposit &&
      assignTo.maxSeatsAllowed
    ) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  }, [assignTo]);

  return (
    <>
      <Modal.Body className="d-flex-column">
        <Form className="d-flex-column flex-grow-1">
          {/* SKIP STEP 1 -> IF COMP */}
          {step === 1 && !isComplimentary ? (
            <>
              <div className="modal-body-heading">
                <h1 className="modal-body-heading-title">Add pricing</h1>
                <p className="mt-0 normal">
                  The fan will receive an email with instructions to accept the
                  assigned package.
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="modal-body-heading">
                <h1 className="modal-body-heading-title">Create Invite</h1>
                <small className="subtitle subtitle--dark">
                  Buyer will receive an email with instructions to select seats
                  for group.
                </small>
              </div>
              <AssignTo
                assignTo={assignTo}
                onAssignToChange={handleAssignToChange}
                isValidEmail={isValidEmail}
                setIsValidEmail={setIsValidEmail}
                isValidNumber={isValidNumber}
                setIsValidNumber={setIsValidNumber}
              />
            </>
          )}
          {alert.show && (
            <Alert variant={alert.variant} className="mt-4">
              <p>{alert.message}</p>
            </Alert>
          )}
          <Stack
            direction="horizontal"
            className={`btn-group-flex ${
              step === 2 && !isComplimentary ? "justify-content-between" : ""
            } `}
          >
            <Stack direction="horizontal">
              <Button variant="default" size="lg" onClick={closeModal}>
                Cancel
              </Button>
              <Button
                size="lg"
                className={`btn-width btn-width-sm--flex-item`}
                disabled={!isValid || isSaving}
                onClick={handleSave}
              >
                Submit
              </Button>
            </Stack>
          </Stack>
        </Form>
      </Modal.Body>
    </>
  );
}
